module.exports = __webpack_public_path__ + "static/img/best_cin-media-crowd.cb35748.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/best_cin-media-crowd.jpg
// module id = 172
// module chunks = 0